import { useTranslation } from "react-i18next";
import { Outlet, useNavigate, useLocation } from "react-router";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";

export const Users = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();

    // Determine current tab based on URL
    const getCurrentTab = () => {
        const path = location.pathname;
        if (path.includes("/roles")) {
            return "roles";
        } else if (path.includes("/users") || path.endsWith("/users")) {
            return "users";
        }
        return "users"; // default
    };

    const currentTab = getCurrentTab();

    return (
        <>
            <title>{t("users.title")}</title>
            <div className="space-y-6">
                <h1 className="font-heading text-3xl font-bold tracking-tight">{t("users.title")}</h1>

                <Tabs value={currentTab}>
                    <TabsList>
                        <TabsTrigger value="users" onClick={() => navigate("")}>
                            {t("users.users.title")}
                        </TabsTrigger>
                        <TabsTrigger value="roles" onClick={() => navigate("roles")}>
                            {t("users.roles.title")}
                        </TabsTrigger>
                    </TabsList>
                </Tabs>

                <Outlet />
            </div>
        </>
    );
};
